import SecureLS from 'secure-ls'
import { StorageLike } from 'pinia-plugin-persistedstate'
export default () => {
  if (!process.client) {
    return null
  }
  const ls = new SecureLS({ isCompression: true })
  return {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value)
  } as StorageLike
}
